export default {"src":"/_next/static/media/ra-safety.d8479446.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};